import { render, staticRenderFns } from "./BackendErrors.vue?vue&type=template&id=8c0d785c&scoped=true"
import script from "./BackendErrors.vue?vue&type=script&lang=ts"
export * from "./BackendErrors.vue?vue&type=script&lang=ts"
import style0 from "./BackendErrors.vue?vue&type=style&index=0&id=8c0d785c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0d785c",
  null
  
)

export default component.exports